const Facebook = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="4122"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M1008 512C1008 238 786 16 512 16S16 238 16 512c0 247.56 181.38 452.76 418.5 490V655.38h-126V512h126v-109.28c0-124.3 74-192.96 187.34-192.96 54.28 0 111.04 9.68 111.04 9.68v122h-62.56c-61.6 0-80.82 38.24-80.82 77.46V512h137.56l-22 143.38h-115.56V1002C826.62 964.76 1008 759.56 1008 512z"
      fill={color}
      p-id="4123"
    ></path>
  </svg>
);

export default Facebook;
